import { MouseEvent } from "react";
import { BlockTitle } from "@blocks/Blocks";
import SplideArrows from "@components/Slider/components/SplideArrows";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack,
} from "@greglaisph/react-splide";
import ConstituenciesToWatchCard from "@pages/SingaporeGe/2025/components/ConstituenciesToWatch/ConstituenciesToWatchCard";
import { useSendInViewGTM } from "@pages/SingaporeGe/2025/hooks/useSendInViewGTM";
import { ConstituenciesToWatchProps } from "@pages/SingaporeGe/2025/utils/types";
import { isPrevSlide } from "@src/app/pages/SingaporeGe/2025/utils/constants";

export default function ConstituenciesToWatch({
  configData: config,
  constituenciesData = [],
  testId = "constituencies-to-watch-component",
  className,
}: ConstituenciesToWatchProps): React.ReactElement {
  const sendDataToGTM = useGTMDispatch();
  const { gaObject, title } = config || {};

  const { ref: constituenciesRef } = useSendInViewGTM({
    eventsObject: gaObject?.eventObject,
  });

  const options: Options = {
    pagination: false,
    type: "slide",
    perMove: 1,
    gap: "1rem",
    focus: 0,
    omitEnd: true,
    perPage: 1,
    arrows: false,
    padding: { right: "2.5rem", left: "0" },
    mediaQuery: "min",
    breakpoints: {
      1024: {
        perPage: 3,
        arrows: constituenciesData?.length > 3,
        padding: { right: 0, left: 0 },
      },
    },
  };

  const sendGtmEventOnClick = (element: MouseEvent<HTMLButtonElement>) => {
    const label =
      (element.target as HTMLButtonElement).getAttribute("aria-label") || "";

    const dataObj = {
      event: "custom_event",
      eventCategory: "GE 2025",
      eventAction: "click right",
      eventLabel: "constituencies to watch",
    };

    if (isPrevSlide.includes(label)) {
      dataObj.eventAction = "click left";
    }

    sendDataToGTM(dataObj);
  };

  return (
    <div data-testid={testId} ref={constituenciesRef} className={className}>
      {title ? <BlockTitle text={title} rootClassName="mb-4" /> : null}

      {constituenciesData.length > 0 ? (
        <div>
          <Splide
            options={options}
            tag="div"
            hasTrack={false}
            className="h-full items-stretch"
          >
            <SplideTrack>
              {constituenciesData.map((constitueny) => {
                return (
                  <SplideSlide key={constitueny.title}>
                    <ConstituenciesToWatchCard
                      constituenciesData={constitueny}
                    />
                  </SplideSlide>
                );
              })}
            </SplideTrack>

            <SplideArrows
              onClick={(element) => {
                sendGtmEventOnClick(element);
              }}
              className="absolute -top-14 right-0 flex flex-row items-center justify-center gap-2"
            />
          </Splide>
        </div>
      ) : null}
    </div>
  );
}
